import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full py-8 border-t border-border bg-card">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        {/* Ad Placeholder - Footer */}
        <div className="ad-slot w-full h-24 bg-muted/50 rounded-lg flex items-center justify-center text-sm text-muted-foreground border border-border mb-8">
          Advertisement Space
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="font-bold text-lg mb-3 bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              <Link to="/">NameBioLab</Link>
            </h3>
            <p className="text-sm text-muted-foreground">
              Create catchy social media bios and unique usernames instantly with AI. <Link to="/about" className="text-primary hover:underline">Learn more about us</Link> and our <a href="#generator" className="text-primary hover:underline">free AI generator tool</a>.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Resources</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/resources" className="text-muted-foreground hover:text-primary transition-colors">
                  Templates & Examples
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
                  Blog & Tips
                </Link>
              </li>
              <li>
                <a href="/#generator" className="text-muted-foreground hover:text-primary transition-colors">
                  AI Username Generator
                </a>
              </li>
              <li>
                <a href="/#generator" className="text-muted-foreground hover:text-primary transition-colors">
                  AI Bio Generator
                </a>
              </li>
              <li>
                <a href="/#how-it-works" className="text-muted-foreground hover:text-primary transition-colors">
                  How It Works
                </a>
              </li>
              <li>
                <a href="/#use-cases" className="text-muted-foreground hover:text-primary transition-colors">
                  Use Cases & Platforms
                </a>
              </li>
              <li>
                <a href="/#faq" className="text-muted-foreground hover:text-primary transition-colors">
                  FAQ & Help
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-6 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} NameBioLab. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
